import store from "."
import { redirectToResultUrl } from "../plugins/helper"
import config from '../../config.json'


let activeSocket = null
let heartbeatTimer = null
let reconnectTimer = null

let reconnectAttempts = 0
let isRevoked = false

const MAX_RECONNECT_ATTEMPTS = 5
const HEARTBEAT_TIMEOUT = 70000 // 70s

function resetHeartbeat(socket) {
    clearTimeout(heartbeatTimer)

    heartbeatTimer = setTimeout(() => {
        console.warn("[ws] heartbeat timeout")

        socket.close()
    }, HEARTBEAT_TIMEOUT)

}

function clearSocketState() {
    clearTimeout(heartbeatTimer)
    clearTimeout(reconnectTimer)

    heartbeatTimer = null
    reconnectTimer = null
}

function reconnect({ userId, sessionId, onMessage, onClose, }) {
    if (isRevoked) {
        return
    }

    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
        console.warn("[ws] max reconnect reached")
        return
    }

    const delay = Math.min(1000 * (reconnectAttempts + 1), 5000)

    reconnectTimer = setTimeout(() => {
        reconnectAttempts++

        createSocket({
            userId,
            sessionId,
            onMessage,
            onClose,
        })
    }, delay)
}

export function createSocket({ userId, sessionId, onMessage, onClose, }) {
    // prevent duplicate connection
    if (activeSocket && (
        activeSocket.readyState ===
        WebSocket.OPEN ||
        activeSocket.readyState ===
        WebSocket.CONNECTING
    )
    ) {
        return activeSocket
    }

    const protocol = window.location.protocol === "https:" ? "wss" : "ws"
    const host = config.api_base_url.replace(/^https?:\/\//, "")

    const url =
        `${protocol}://${host}/ws` +
        `?flag=1` +
        `&user_id=${userId}` +
        `&session_id=${sessionId}`

    const socket = new WebSocket(url)

    activeSocket = socket

    socket.onopen = () => {
        reconnectAttempts = 0

        resetHeartbeat(socket)
    }

    socket.onmessage = (event) => {
        resetHeartbeat(socket)

        try {
            const payload = JSON.parse(event.data)

            if (payload.type === "session_revoked") {
                isRevoked = true
            }

            if (onMessage) {
                onMessage(payload)
            }
        } catch (err) {
            console.error(
                "[ws] invalid payload:",
                err
            )
        }
    }

    socket.onclose = () => {
        clearSocketState()

        activeSocket = null

        if (onClose) { onClose() }

        // reconnect only if not revoked
        if (!isRevoked) {
            reconnect({
                userId,
                sessionId,
                onMessage,
                onClose,
            })
        }
    }

    socket.onerror = (error) => {
        console.error("[ws] error:", error)
    }

    return socket


}

export function closeSocket() {
    clearSocketState()

    if (activeSocket) {
        activeSocket.close()
        activeSocket = null
    }


}

export function handleSocketEvent(payload) {
    switch (payload.type) {
        case "session_revoked":
            store.setState({
                isMaintenance: true,
                message: payload.message,
                message_type: 'session_revoked',
                message_title: payload.message_title || 'Warning!'
            })

            break

        default:
    }
}
